export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_REMOVE_ADDON_ITEM = 'CART_REMOVE_ADDON_ITEM';
export const CART_UPDATE_QUANTITIES = 'CART_UPDATE_QUANTITIES';
export const CART_UPDATE_QUANTITY = 'CART_UPDATE_QUANTITY';
export const CART_ADD_ITEM_WITH_ADDON = 'CART_ADD_ITEM_WITH_ADDON';
export const CART_EMPTY = 'CART_EMPTY';
export const CART_TOGGLE = 'CART_TOGGLE';